import React from 'react';
import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconAttachments } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { closeOverflowMenuIfOpen } from '../../../toolbox/actions.web';
import { toggleAttachments } from '../../actions';
import AttachmentsCounter from './AttachmentsCounter';
/**
 * Implementation of a button for accessing attachments pane.
 */
class AttachmentsButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.openAttachments';
        this.toggledAccessibilityLabel = 'toolbar.accessibilityLabel.closeAttachments';
        this.icon = IconAttachments;
        this.label = 'toolbar.openAttachments';
        this.toggledLabel = 'toolbar.closeAttachments';
        this.tooltip = 'toolbar.openAttachments';
        this.toggledTooltip = 'toolbar.closeAttachments';
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._attachmentsOpen;
    }
    /**
     * Overrides AbstractButton's {@link Component#render()}.
     *
     * @override
     * @protected
     * @returns {boReact$Nodeolean}
     */
    render() {
        return (React.createElement("div", { className: 'toolbar-button-with-badge', key: 'attachmentscontainer' },
            super.render(),
            React.createElement(AttachmentsCounter, null)));
    }
    /**
     * Handles clicking the button, and toggles the attachments.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        sendAnalytics(createToolbarEvent('toggle.attachments', {
            enable: !this.props._attachmentsOpen
        }));
        dispatch(closeOverflowMenuIfOpen());
        dispatch(toggleAttachments());
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    return {
        _attachmentsOpen: state['features/attachments'].isOpen
    };
};
export default translate(connect(mapStateToProps)(AttachmentsButton));
